<template>
  <v-form v-model="valid" @submit="signUp">
    <div class="text-xs-center">
      <v-snackbar
        v-model="snackbar"
        color="white"
        :top="true"
        :multi-line="true"
        class="snackBarTxt"
      >
        {{ text }}
        <v-btn
          flat
          @click="snackbar = false"
          class="snackBarTxt"
        >
          Fechar
        </v-btn>
      </v-snackbar>

      <v-layout pa-2 class="lightbox white--text">
        <v-flex>
          <div class="cabecalho animated fadeIn delay-1s d-flex align-center justify-center">
            <v-img
              :src="require('../assets/ZipperWhite.png')"
              contain
              max-width="420px"
            />
          </div>

          <v-layout align-center justify-center row>
            <v-flex xs10 lg3 class="px-4 margin-to-top animated fadeInUp delay-1s">
              <v-text-field
                label="Email"
                v-model="email"
                color="white"
                prepend-icon="person"
                dark
                clearable
                @click:clear="limparForm"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center row>
            <v-flex xs10 lg3 class="px-4 animated fadeInUp delay-1s">
              <v-text-field
                autocomplete="new-password"
                v-model="password"
                label="Senha"
                color="white"
                prepend-icon="vpn_key"
                dark
                :append-icon="show ? 'visibility' : 'visibility_off'"
                @click:append="show = !show"
                :type="show ? 'text' : 'password'"
                :rules="[rules.required, rules.min]"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout align-center justify-center row>
            <v-flex xs10 lg3 class="px-4 animated fadeInUp delay-1s">
              <v-text-field
                v-model="repassword"
                label="Confirme sua Senha"
                color="white"
                prepend-icon="vpn_key"
                dark
                :append-icon="show ? 'visibility' : 'visibility_off'"
                @click:append="show = !show"
                :type="show ? 'text' : 'password'"
                :rules="[rules.required, rules.min, rules.passwordMatches]"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-flex class="mt-3">
            <v-btn type="submit" round dark outline class="animated fadeInRight delay-1s" >
              <span class="text-lowercase">Registrar</span>
            </v-btn>
          </v-flex>

          <v-flex>
            <v-flex class="mt-3 mb-2 animated fadeIn delay-2s">
              <a href="/login">Ja possui Login?</a>
            </v-flex>
            <div class="margin-to-bottom">
            <v-btn icon dark outline class="animated fadeInLeft delay-1s" href="https://www.facebook.com/konselior/" target="_blank">
              <v-icon small>fab fa-facebook-f</v-icon>
            </v-btn>
            <v-btn icon dark outline class="animated fadeInUp delay-1s" href="https://www.linkedin.com/company/konselior/about/" target="_blank">
              <v-icon small>fab fa-linkedin-in</v-icon>
            </v-btn>
            <v-btn icon dark outline class="animated fadeInRight delay-1s" href="http://konselior.com" target="_blank">
              <v-icon small>far fa-envelope</v-icon>
            </v-btn>
            </div>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
  </v-form>
</template>

<script>
export default {
  methods: {
    limparForm() {
      this.password = '';
      this.repassword = '';
    },
    signUp(e) {
      e.preventDefault();
      if (this.valid) {
        this.$auth.signUp(this.email, this.password, (err, resp) => {
          if (err && err.code == 'user_exists') {
            this.color = '#fffff';
            this.text = 'Usuário já existe, tente outro usuário ou realize o login.';
            this.snackbar = true;
            console.log('Error', err);
          } else if (err) {
            this.color = '#fffff';
            this.text = 'Ocorreu um erro, por favor tente novamente mais tarde.';
            this.snackbar = true;
            console.log('Error', err);
          } else {
            this.color = '#fffff';
            this.text = 'Usuário criado com sucesso!';
            this.snackbar = true;
            setTimeout(() => this.$router.push('login'), 1000);
          }
        });
      }
    },
  },
  data() {
    return {
      loading: false,
      valid: null,
      snackbar: false,
      text: '',
      color: '',
      email: null,
      show: false,
      password: null,
      repassword: null,
      rules: {
        required: value => !!value || 'Campo Obrigatorio',
        min: v => (v && v.length >= 8) || 'Minimo de 8 caracteres',
        passwordMatches: v => v === this.password || 'As senhas não conferem.',
        emailMatch: () => "The email s and password you entered don't match",
      },
    };
  },
};
</script>

<style>
</style>

<style scoped>
a {
  color: white;
}
.snackBarTxt{
    color: #099AB1 !important;
    caret-color: #099AB1 !important;
}
.cabecalho {
  font-size: 50px;
  margin-top: 50px;
  letter-spacing: 2px;
}
.icon-cabecalho {
  font-size: 30px !important;
  padding-right: 4px;
  padding-bottom: 10px;
}
.margin-to-top {
  margin-top: 80px;
}
.margin-to-bottom {
  margin-top: 70px;
}
</style>
